import { Injectable } from '@angular/core';

import { AddressMapper } from 'ish-core/models/address/address.mapper';
import { BasketInclude } from 'ish-core/models/basket/basket.interface';
import { LineItemMapper } from 'ish-core/models/line-item/line-item.mapper';
import { OrderIncludes } from 'ish-core/models/order/order.interface';
import { ShippingMethodMapper } from 'ish-core/models/shipping-method/shipping-method.mapper';

import { BucketBaseData } from './bucket.interface';
import { Bucket } from './bucket.model';

@Injectable({ providedIn: 'root' })
export class BucketMapper {
  static fromData(bucketData: BucketBaseData, basketIncluded?: BasketInclude, orderIncluded?: OrderIncludes): Bucket {
    if (!bucketData) {
      throw new Error(`bucketData is required`);
    }

    const includedData = basketIncluded || orderIncluded;
    const includedLineItems = includedData?.lineItems || {};

    const shipToAddress = includedData?.buckets_shipToAddress?.[bucketData.shipToAddress];
    const shippingMethod = includedData?.buckets_shippingMethod?.[bucketData.shippingMethod];
    const lineItems =
      bucketData.lineItems?.map(lineItemId =>
        LineItemMapper.fromData(includedLineItems[lineItemId], includedData?.lineItems_discounts)
      ) || [];
    const desiredDeliveryDate = lineItems[0]?.desiredDeliveryDate || '';

    return {
      id: bucketData.id,
      shipToAddress: shipToAddress ? AddressMapper.fromData(shipToAddress) : undefined,
      shippingMethod: shippingMethod ? ShippingMethodMapper.fromData(shippingMethod) : undefined,
      lineItems,
      desiredDeliveryDate,
    };
  }
}
